<new-flowbanner *ngIf='!isLoading' [showPromo]="true"></new-flowbanner>
<div *ngIf="enablePromo && !isLoading" class="w-100 d-block d-md-none contenedor-promo-mobile">
  <img class="img-promo-mobile" src="./assets/img/m_arriendo.png" [width]="360" [height]="265" priority
    alt="Promoción e-SIM 10GB incluidos" />
</div>
<app-newstepper *ngIf='!isLoading'></app-newstepper>

<app-new-loader *ngIf='isLoading'></app-new-loader>

<main class="container" [hidden]="!loaded">
  <section class="row pt-lg-4">
    <!-- Columna izquierda (Imagen y mensaje) -->
    <div *ngIf="enablePromo" class="col-12 col-lg-6 flex-column justify-content-center align-items-center pt-lg-5">
      <h1 class="text-center custom-title">
        ¡Recibe hasta <br class="d-none d-lg-block"> $80.000 en Nequi!
      </h1>
      <div class="d-flex justify-content-center">
        <img src="./assets/img/d_arriendo.png" alt="cotizar seguro de arrendamiento"
          class="img-fluid-promo d-none d-lg-block" loading="lazy" />
      </div>
    </div>
    <div *ngIf="!enablePromo" class="col-12 col-lg-6 flex-column justify-content-center align-items-center pt-lg-5">
      <h1 class="text-left custom-title">
        Coticemos tu Seguro de <br class="d-none d-lg-block"> arriendo digital
      </h1>
      <img src="./assets/img/Apartamento.png" alt="cotizar seguro de arrendamiento" class="img-fluid d-none d-lg-block"
        loading="lazy" />
    </div>
    <!-- Columna derecha (Formulario) -->
    <div class="col-12 col-lg-6 d-flex justify-content-center">
      <section>
        <form [formGroup]="inmuebleForm" #cotizadorForm="ngForm">
          <div class="form-container"
            [ngClass]="{ 'form-complete': isFormComplete && inmuebleForm.get('valorArrendamiento')?.valid && inmuebleForm.get('valorAdministracion')?.valid }">
            <h2 class="text-left custom-h2">
              <img [src]="
                  isFormComplete && inmuebleForm.get('valorArrendamiento')?.valid && inmuebleForm.get('valorAdministracion')?.valid
                    ? './assets/img/check32.png'
                    : './assets/img/Casa.svg'
                " alt="Casa" class="imagen-duo" />
              Datos del inmueble
            </h2>
            <!-- Valor mensual de arrendamiento -->
            <div class="mb-4 container-labels">
              <label for="renta" class="form-label label-message">*Valor mensual de arrendamiento</label>
              <input id="renta" name="renta" type="text" formControlName="valorArrendamiento" placeholder="Ej: $1200000"
                required class="form-control " [class.is-invalid]="isValidField(inmuebleForm, 'valorArrendamiento')"
                (blur)="onUsoChange()" (change)="validateValueAdmin()" CurrencyFormatter />
              <div class="invalid-feedback" *ngIf="isValidField(inmuebleForm, 'valorArrendamiento')">
                {{ getFieldError(inmuebleForm, 'valorArrendamiento') }}
              </div>
            </div>

            <!-- Valor de la administración -->
            <div class="mb-4 mb-lg-3 container-labels">
              <label for="admin" class="form-label label-message">*Valor de la administración</label>
              <input id="admin" name="admin" type="text" formControlName="valorAdministracion" placeholder="Ej: $250000"
                required class="form-control custom-input"
                [class.is-invalid]="isValidField(inmuebleForm, 'valorAdministracion')"
                (keydown)="true ? validateNumber($event) : null" (blur)="onUsoChange()" (change)="validateValueAdmin()"
                CurrencyFormatter />
              <div class="invalid-feedback" *ngIf="isValidField(inmuebleForm, 'valorAdministracion')">
                {{ getFieldError(inmuebleForm, 'valorAdministracion') }}
              </div>
              <p class="form-text custom-text lh-base">
                Si tu inquilino paga la administración, escribe el valor. Si no,
                escribe $0.
              </p>
            </div>
            @if((inmuebleForm.get('valorArrendamiento')?.value || 0) + (inmuebleForm.get('valorAdministracion')?.value
            || 0) > 5000000){
            <div class="alert alert-danger mt-2">
              La suma de arriendo y administración no debe superar los
              $5.000.000
            </div>
            }

            <!-- Propiedad de uso -->
            <div class="mb-4 container-labels">
              <label class="form-label custom-label">Tu propiedad es de uso</label>

              <div class="radio-buttons">
                <label for="residencial" class="form-check-label custom-radio-label">
                  <input type="radio" id="residencial" name="tipo" formControlName="tipoPropiedad" value="Residencial"
                    (change)="onUsoChange()" class="radio" />
                  Residencial
                </label>
                <label for="comercial" class="form-check-label custom-radio-label">
                  <input type="radio" id="comercial" name="tipo" formControlName="tipoPropiedad" value="Comercial"
                    (change)="onUsoChange()" class="radio-comercial" />
                  Comercial
                </label>
              </div>
              <div class="invalid-feedback" *ngIf="isValidField(inmuebleForm, 'tipoPropiedad')">
                {{ getFieldError(inmuebleForm, 'tipoPropiedad') }}
              </div>
            </div>

            <!-- Duración del contrato -->
            <div class="mb-4 container-labels">
              <label for="duration" class="form-label custom-label-duration">
                Elige la duración del contrato de arrendamiento
              </label>
              <div class="range-container">
                <div class="range-labels">
                  <span [class.active]="inmuebleForm.get('TemporaryContracted')?.value === 6" class="label-6">6
                    meses</span>
                  <input type="range" id="duration" name="duration" formControlName="TemporaryContracted" min="6"
                    max="12" step="6" class="form-range" [style.background]="getSliderBackground()" />
                  <span [class.active]="inmuebleForm.get('TemporaryContracted')?.value === 12" class="label-12">12
                    meses</span>
                </div>
              </div>
            </div>


          </div>

          <div class="mb-5">
            <app-advisor-form (advisorSelected)="handleAdvisorSelected($event)"
              (isValid)="handleAdvisorBehavior($event)"></app-advisor-form>
          </div>
        </form>
        <!-- Formulario adicional que se muestra dependiendo del estado de los radios -->
        @if(inmuebleForm.get('valorArrendamiento')?.valid && inmuebleForm.get('valorAdministracion')?.valid &&
        inmuebleForm.get('tipoPropiedad')?.value==="Residencial"){
        <form [formGroup]="inmuebleForm" #inquilinoForm>
          <div class="inquilino-container"
            [ngClass]="{ 'form-complete': inmuebleForm.get('tieneInquilino')?.value === 'Sí' }">
            <div class="inquilino-header">
              <img [ngClass]="{ 'ms-3': inmuebleForm.get('tieneInquilino')?.value === 'Sí' }" class="inquilino-img"
                [src]="imagenInquilino" alt="Familia to check" />
              <label class="inquilino-label">¿Ya tienes un inquilino?</label>
            </div>

            <div class="inquilino-description">
              <p>
                Esta información nos ayudará a personalizar la cotización de tu
                seguro.
              </p>
            </div>
            <div class="inquilino-options">
              <label>
                <input type="radio" name="inquilino" formControlName="tieneInquilino" value="Sí"
                  (change)="onUsoChange()" />
                Sí, tengo inquilino
              </label>
              <label>
                <input type="radio" name="inquilino" formControlName="tieneInquilino" value="No"
                  (change)="onUsoChange()" />
                No, aún no tengo inquilino
              </label>
            </div>
            <div class="invalid-feedback" *ngIf="isValidField(inmuebleForm, 'tieneInquilino')">
              {{ getFieldError(inmuebleForm, 'tieneInquilino') }}
            </div>
          </div>
        </form>
        }

        <!-- Formulario para cuando no se tiene inquilino -->
        @if(inmuebleForm.get('tieneInquilino')?.value==="No"){
        <!-- Formulario adicional cuando no tienes un inquilino -->
        <form [formGroup]="contactForm" #hasInquilino>
          <div class="form-container-no">
            <div class="form-header-no">
              <img class="img-fluid-no" src="./assets/img/svg/Escudo-seguro.svg" alt="Ícono de seguro" />
            </div>

            <div class="form-description-no">
              <p class="form-title-no">
                Para comprar tu Seguro de Arriendo, es necesario que tengas un
                inquilino.
              </p>
            </div>

            <div class="form-info-no">
              <p>
                Si todavía no tienes uno, déjanos tu correo y te mandamos todo lo
                que necesitas saber para que estés listo cuando llegue el momento.
              </p>
            </div>

            <div class="form-fields-no">
              <label for="LastName" [ngClass]="getLabelClasses(contactForm, 'LastName')">*¿Cómo te llamas?</label>
              <input type="text" id="LastName" placeholder="Escribe tu nombre" formControlName="LastName"
                class="form-input-no" [class.is-invalid]="isValidField(contactForm, 'LastName')"
                (keydown)="validateAlpha($event)" />
              <div class="invalid-feedback" *ngIf="isValidField(contactForm, 'LastName')">
                {{ getFieldError(contactForm, 'LastName') }}
              </div>

              <!-- <label for="Mail" [ngClass]="getLabelClasses(contactForm, 'Mail')">*¿Cuál es tu correo electrónico?</label>
                <input
                  type="email"
                  id="Mail"
                  placeholder="Ej: usuario@correo.com"
                  formControlName="Mail"
                  class="form-input-no"
                  [class.is-invalid]="isValidField(contactForm, 'Mail')"
                />
                <div class="invalid-feedback" *ngIf="isValidField(contactForm, 'Mail')">
                  {{ getFieldError(contactForm, 'Mail') }}
                </div> -->

              <generalinput [form]="contactForm" controlName="Mail" label="*¿Cuál es tu correo electrónico?"
                alertMessage="Asegúrate de llenar este campo." placeholder="Ej: usuario@correo.com">
              </generalinput>

              <button (click)="continue()" class="btn continue-btn-no"
                [disabled]="contactForm.invalid || !isFormComplete || isValidAdvisor()">
                Continuar
              </button>
            </div>
          </div>
        </form>
        }

        <!-- Formulario para cuando ya se tiene inquilino -->
        @if(inmuebleForm.get('tieneInquilino')?.value==="Sí"){
        <div class="form-container-si" #hasInquilino>
          <div class="form-header-si">
            <img class="img-fluid-si" src="./assets/img/svg/Educación.svg" alt="Ícono de educación" />
            <p class="form-title-si">Datos del inquilino</p>
          </div>
          <p class="form-description-si">
            Esta información la usamos para hacer el análisis financiero de tu
            inquilino.
          </p>
          <form [formGroup]="tenantForm">
            <div class="mb-3">
              <general-select [form]="tenantForm" controlName="DocumentType" label="Tipo de identificación"
                [isReFill]="true">
              </general-select>
              <!-- <label for="tipo-id" class="form-label-si" [ngClass]="getLabelClasses(tenantForm, 'tipoIdentificacion')"
                  >Tipo de identificación</label
                >
                <select 
                  id="tipo-id" 
                  name="tipo-id" 
                  formControlName="DocumentType"
                  class="form-select-si ng-valid ng-touched"
                  [class.is-invalid]="isValidField(tenantForm, 'tipoIdentificacion')"
                >
                  <option value="C">
                    Cédula de ciudadanía
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isValidField(tenantForm, 'tipoIdentificacion')">
                  {{ getFieldError(tenantForm, 'tipoIdentificacion') }}
                </div> -->
            </div>

            <div class="mb-3 mb-lg-4">
              <generalinput [form]="tenantForm" controlName="DocumentNumber" [isNumberOnly]="true"
                label="*Número de identificación" alertMessage="Este campo debe tener entre 7 y 10 dígitos"
                placeholder="Digita el número sin puntos" class="documentNum">
              </generalinput>
              <!-- <label for="num-id" class="form-label label-message" [ngClass]="getLabelClasses(tenantForm, 'numeroIdentificacion')"
                  >*Número de identificación</label
                >
                <input
                  id="num-id"
                  type="text"
                  name="num-id"
                  formControlName="DocumentNumber"
                  placeholder="Digita el número sin puntos"
                  
                  class="form-control-si"
                  (keydown)="true ? validateNumber($event) : null" 
                  [class.is-invalid]="isValidField(tenantForm, 'numeroIdentificacion')"
                />
                <div class="invalid-feedback" *ngIf="isValidField(tenantForm, 'numeroIdentificacion')">
                  {{ getFieldError(tenantForm, 'numeroIdentificacion') }}
                </div> -->
            </div>





            <div class="mb-3 check">
              <general-chebox class="color-text-authorization" [form]="tenantForm"
                controlName="PersonalDataAuthorization" label="*Tipo de identificación" [useAlternativeText]="false">
              </general-chebox>

            </div>
          </form>
        </div>
        <button type="submit" class="btn btn-primary-si" (click)="openModal()"
          [disabled]="tenantForm.invalid || !isFormComplete || isValidAdvisor() ">
          <span *ngIf="isMobile">Cotizar</span>
          <span *ngIf="!isMobile">Cotizar</span>
        </button>
        }
        <!-- Modal -->
        <div class="modal-container" *ngIf="isModalOpen">
          <div class="modal">
            <span class="close-btn" (click)="closeModalButton()">
              <img class="cerrar-blanco" src="./assets/img/close-white.png" alt="Cerrar" />
            </span>

            <div class="modal-content" [formGroup]="tenantForm">
              <h2 class="modal-title">
                ¿Confirmas que esta es la <br> cédula del inquilino?
              </h2>

              <!-- Campo de entrada con el valor de la cédula -->
              <div class="input-container">
                <!-- <label for="cedula" class="input-label">CC</label>
                <input (keydown)="validateNumber($event)" id="cedula" formControlName="DocumentNumber" class="form-label-input" /> -->
                <img src="./assets/img/Lapiz.png" alt="Editar" class="input-icon" />

                <generalinput [form]="tenantForm" controlName="DocumentNumber" [isNumberOnly]="true" label="CC"
                  alertMessage="Este campo debe tener entre 7 y 10 dígitos" placeholder="" class="documentNumModal">
                </generalinput>
              </div>

              <p class="modal-description">
                Con esta cédula realizaremos el
                <span class="modal-description-span">análisis financiero</span>.
                Si te equivocaste en algún número, ¡corrígela!<span class="modal-description-span"> <br>
                  Si está correcto, da clic en Continuar.</span>
              </p>

              <button class="btn btn-primary" (click)="continue()"
                [disabled]="tenantForm.invalid || !isFormComplete || isClicked || isValidAdvisor()">
                Continuar
              </button>
            </div>
          </div>
        </div>

      </section>
    </div>
  </section>
</main>

<app-footer-app *ngIf='!isLoading'></app-footer-app>